import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["classNames", "range", "start", "step", "disabled", "onSubmit", "translations"];
import React, { useState } from 'react';
import { cx } from "./lib/cx.js";
// if the default value is undefined, React considers the component uncontrolled initially, which we don't want 0 or NaN as the default value
var unsetNumberInputValue = '';
export function RangeInput(_ref) {
  var _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
      _ref$range = _ref.range,
      min = _ref$range.min,
      max = _ref$range.max,
      _ref$start = _slicedToArray(_ref.start, 2),
      minValue = _ref$start[0],
      maxValue = _ref$start[1],
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      disabled = _ref.disabled,
      _onSubmit = _ref.onSubmit,
      translations = _ref.translations,
      props = _objectWithoutProperties(_ref, _excluded);

  var values = {
    min: minValue !== -Infinity && minValue !== min ? minValue : unsetNumberInputValue,
    max: maxValue !== Infinity && maxValue !== max ? maxValue : unsetNumberInputValue
  };

  var _useState = useState(values),
      _useState2 = _slicedToArray(_useState, 2),
      prevValues = _useState2[0],
      setPrevValues = _useState2[1];

  var _useState3 = useState({
    from: values.min,
    to: values.max
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      _useState4$ = _useState4[0],
      from = _useState4$.from,
      to = _useState4$.to,
      setRange = _useState4[1];

  if (values.min !== prevValues.min || values.max !== prevValues.max) {
    setRange({
      from: values.min,
      to: values.max
    });
    setPrevValues(values);
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx(cx('ais-RangeInput', classNames.root), disabled && cx('ais-RangeInput--noRefinement', classNames.noRefinementRoot), props.className)
  }), /*#__PURE__*/React.createElement("form", {
    className: cx('ais-RangeInput-form', classNames.form),
    onSubmit: function onSubmit(event) {
      event.preventDefault();

      _onSubmit([from, to]);
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: cx('ais-RangeInput-label', classNames.label)
  }, /*#__PURE__*/React.createElement("input", {
    className: cx('ais-RangeInput-input', classNames.input, 'ais-RangeInput-input--min', classNames.inputMin),
    type: "number",
    min: min,
    max: max,
    value: from === null || from === void 0 ? void 0 : from.toString() // Strips leading `0` from a positive number value
    ,
    step: step,
    placeholder: min === null || min === void 0 ? void 0 : min.toString(),
    disabled: disabled,
    onInput: function onInput(_ref2) {
      var currentTarget = _ref2.currentTarget;
      return setRange({
        from: Number(currentTarget.value),
        to: to
      });
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: cx('ais-RangeInput-separator', classNames.separator)
  }, translations.separatorElementText), /*#__PURE__*/React.createElement("label", {
    className: cx('ais-RangeInput-label', classNames.label)
  }, /*#__PURE__*/React.createElement("input", {
    className: cx('ais-RangeInput-input', classNames.input, 'ais-RangeInput-input--max', classNames.inputMax),
    type: "number",
    min: min,
    max: max,
    value: to === null || to === void 0 ? void 0 : to.toString() // Strips leading `0` from a positive number value
    ,
    step: step,
    placeholder: max === null || max === void 0 ? void 0 : max.toString(),
    disabled: disabled,
    onInput: function onInput(_ref3) {
      var currentTarget = _ref3.currentTarget;
      return setRange({
        from: from,
        to: Number(currentTarget.value)
      });
    }
  })), /*#__PURE__*/React.createElement("button", {
    className: cx('ais-RangeInput-submit', classNames.submit),
    type: "submit"
  }, translations.submitButtonText)));
}